import React, { useEffect } from 'react'
import DashboardHeader from "../layouts/dashboard_header";
import SideMenu from "../layouts/dashboard_menu";
import DashboardFooter from "../layouts/dashboard_footer";
import Canvas from "../layouts/dahboard_canvas";
import Staff from './Staff';

const AddStaff: React.FC = () => {
    useEffect(() => {
        document.title = 'Uzima Health Care - Add Staff';
    }, []);

    return (
        <>
            <DashboardHeader />
            <SideMenu />
            <div className="main-content">
                <div className="page-content">
                    <div className="sc-wrap">
                        <Staff initialView="create" />
                    </div>
                </div>
                <DashboardFooter />
            </div>
            <Canvas />
        </>
    )
}

export default AddStaff